import React from "react";
import { useLang } from "../LangContext";
import { useReveal } from "../hooks/useReveal";
import { Kicker } from "./Mission";
import { Users, Baby, ArrowUpRight } from "lucide-react";

const ADULTS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/0bf0a0ef-25eb-404f-ad9c-37c974297201/images/bdc319acda002a12b5dc220bac97890a38b5a7b283abfbd9cb1ee28100071611.png";
const KIDS_IMG =
  "https://static.prod-images.emergentagent.com/jobs/0bf0a0ef-25eb-404f-ad9c-37c974297201/images/683ab780ba954d4a58cde75bd07e83e148d99ae3f8d87bb43945bc4290fee786.png";

export const Universes = () => {
  const { t } = useLang();
  const ref = useReveal();

  const blocks = [
    {
      img: ADULTS_IMG,
      tag: t.universes.adults.tag,
      title: t.universes.adults.title,
      text: t.universes.adults.text,
      Icon: Users,
      tone: "from-orange-500/30 via-fuchsia-500/20 to-transparent",
      pill: "bg-orange-500/15 text-orange-200 ring-orange-400/30",
      testId: "universe-adults",
    },
    {
      img: KIDS_IMG,
      tag: t.universes.kids.tag,
      title: t.universes.kids.title,
      text: t.universes.kids.text,
      Icon: Baby,
      tone: "from-cyan-400/30 via-violet-500/20 to-transparent",
      pill: "bg-cyan-400/15 text-cyan-200 ring-cyan-400/30",
      testId: "universe-kids",
    },
  ];

  return (
    <section
      id="universes"
      data-testid="universes-section"
      className="relative py-24 lg:py-32 reveal"
      ref={ref}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <Kicker label={t.universes.kicker} />
          <h2 className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
            Deux <span className="text-baj-grad">univers</span>, un même goût du jeu.
          </h2>
        </div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6 lg:gap-8">
          {blocks.map((b) => (
            <article
              key={b.testId}
              data-testid={b.testId}
              className="group relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#0f1422] min-h-[480px] hover:-translate-y-1.5 transition-transform duration-500"
            >
              <img
                src={b.img}
                alt=""
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${b.tone}`} />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0e1a] via-[#0a0e1a]/85 to-[#0a0e1a]/10" />

              <div className="relative h-full flex flex-col justify-end p-7 lg:p-10">
                <div
                  className={`inline-flex items-center gap-2 self-start rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wider ring-1 ${b.pill}`}
                >
                  <b.Icon className="w-3.5 h-3.5" strokeWidth={2.5} />
                  {b.tag}
                </div>
                <h3 className="font-display mt-5 text-3xl sm:text-4xl font-extrabold text-white leading-tight max-w-md">
                  {b.title}
                </h3>
                <p className="mt-4 text-slate-300 leading-relaxed max-w-xl">
                  {b.text}
                </p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white/80">
                  <span className="h-px w-10 bg-white/40" />
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
